import { useLanguage } from "@/context/LanguageContext";

export const BrandMarquee = () => {
  const { t } = useLanguage();
  const words = t.marquee || [];

  return (
    <section data-testid="marquee" className="py-7 md:py-9 border-b border-border overflow-hidden bg-card/50">
      <div className="flex select-none overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
        <div className="flex shrink-0 animate-marquee items-center justify-around gap-10 whitespace-nowrap">
          {words.map((w, idx) => (
            <span key={`m1-${idx}`} className="inline-flex items-center gap-10 text-xl sm:text-2xl md:text-3xl font-extrabold tracking-wider text-foreground/80 uppercase">
              {w}
              <span className="h-2 w-2 rounded-full bg-accent" />
            </span>
          ))}
        </div>
        <div className="flex shrink-0 animate-marquee items-center justify-around gap-10 whitespace-nowrap" aria-hidden="true">
          {words.map((w, idx) => (
            <span key={`m2-${idx}`} className="inline-flex items-center gap-10 text-xl sm:text-2xl md:text-3xl font-extrabold tracking-wider text-foreground/80 uppercase">
              {w}
              <span className="h-2 w-2 rounded-full bg-accent" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
